var map = {
	"./add-section.svg": 4228,
	"./add-step.svg": 4349,
	"./arrow-select.svg": 7005,
	"./bell.svg": 689,
	"./border.svg": 2134,
	"./calendar.svg": 4776,
	"./delete-gray.svg": 733,
	"./delete.svg": 612,
	"./download-gray.svg": 6287,
	"./download.svg": 2650,
	"./drag.svg": 2811,
	"./edit-fill.svg": 7929,
	"./edit.svg": 2291,
	"./empty-user.svg": 3436,
	"./endowments-fill.svg": 6757,
	"./endowments.svg": 3798,
	"./files.svg": 7453,
	"./globe.svg": 8403,
	"./google.svg": 3365,
	"./logo.svg": 247,
	"./passHide.svg": 6435,
	"./passShow.svg": 9894,
	"./pdf-icon.svg": 6713,
	"./resend.svg": 9613,
	"./setting-fill.svg": 8625,
	"./setting.svg": 3083,
	"./staff-fill.svg": 1362,
	"./staff.svg": 8119,
	"./template.svg": 2604,
	"./uncompleted.svg": 582,
	"./view.svg": 4622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;